import { FileTextOutlined } from '@ant-design/icons'
import { Button, Card, Space, Typography } from 'antd'
import React, { FC, ReactElement } from 'react'

import { MESSAGES } from './constants'
import { DocPreviewPanelProps } from './types'
import styles from './styles.module.scss'

export const DocPreviewPanel: FC<DocPreviewPanelProps> = ({ previewPath }): ReactElement => (
  <Card>
    <Space>
      <Typography.Text type="secondary">
        <FileTextOutlined className={styles.icon} />
      </Typography.Text>
      <Typography.Title level={4} className={styles.title}>
        {MESSAGES.TITLE}
      </Typography.Title>
    </Space>
    <Typography.Paragraph className={styles.description}>{MESSAGES.DESCRIPTION}</Typography.Paragraph>
    <Button type="primary" href={previewPath}>
      {MESSAGES.PREVIEW_BUTTON}
    </Button>
  </Card>
)

export default DocPreviewPanel
